module.exports = __webpack_public_path__ + "img/picture_slt05.71250e42.png";